import React from 'react';
import Icon from '../home/Icon';
import ProductPage from '../product-page/ProductPage';
import { ONLINE_STORE_PAGE } from './onlineStoreData';
import './OnlineStore.css';

// Illustrative store — a fictional brand, prices GST-inclusive.
const PRODUCTS = [
  { name: 'Block-print cushion cover', variant: 'Indigo · 3 colours', price: '₹649', stock: { text: 'Only 2 left', tone: 'warn' }, hue: ['#e0e7ff', '#4338ca'] },
  { name: 'Handloom cotton throw', variant: 'Natural', price: '₹1,890', stock: { text: 'In stock', tone: 'ok' }, hue: ['#fef3c7', '#b45309'] },
  { name: 'Kantha table runner', variant: 'Madder red', price: '₹1,250', stock: { text: 'Sold out', tone: 'slate' }, hue: ['#fee2e2', '#b91c1c'] },
];

// A simple woven-textile swatch so each product tile has a "photo".
const Swatch = ({ bg, fg }) => (
  <svg viewBox="0 0 120 80" className="os-swatch" aria-hidden="true">
    <rect width="120" height="80" fill={bg} />
    {[10, 26, 42, 58, 74].map((y) => <rect key={y} x="0" y={y} width="120" height="3" fill={fg} opacity="0.18" />)}
    <rect x="34" y="16" width="52" height="48" rx="6" fill={fg} opacity="0.85" />
    <circle cx="60" cy="40" r="11" fill={bg} opacity="0.9" />
    <circle cx="60" cy="40" r="5" fill={fg} />
  </svg>
);

const StorefrontMock = () => (
  <div aria-hidden="true">
    <div className="pp-window">
      <div className="pp-window-bar os-bar">
        <span className="os-dots"><i /><i /><i /></span>
        <span className="os-url"><Icon name="lock" size={11} />indigoloom.store.rayaaisuite.com</span>
        <span className="os-bag"><Icon name="shopping-bag" size={14} /><b>2</b></span>
      </div>
      <div className="pp-window-body os-store">
        <div className="os-nav">
          <span className="os-logo">Indigo Loom</span>
          <span className="os-links"><span>Cushions</span><span>Throws</span><span>Table linen</span></span>
        </div>
        <div className="os-banner">
          <div>
            <span className="os-banner-kicker">New collection</span>
            <span className="os-banner-title">Hand block-printed, from our Jaipur workshop</span>
          </div>
          <span className="os-banner-btn">Shop now</span>
        </div>
        <div className="os-grid">
          {PRODUCTS.map((p) => (
            <div className="os-card" key={p.name}>
              <Swatch bg={p.hue[0]} fg={p.hue[1]} />
              <span className={`pp-chip pp-chip--${p.stock.tone} os-stock`}>{p.stock.text}</span>
              <span className="os-name">{p.name}</span>
              <span className="os-variant">{p.variant}</span>
              <span className="os-price">{p.price} <small>incl. GST</small></span>
            </div>
          ))}
        </div>
        <div className="os-powered">Powered by Raya ERP</div>
      </div>
    </div>
    <div className="pp-float pp-float--tr">
      <span className="pp-float-icon pp-float-icon--ok">✓</span>
      <span><strong>Order IL-1042 paid</strong><small>Sales order created · stock allocated</small></span>
    </div>
    <div className="pp-float pp-float--bl">
      <span className="pp-float-icon pp-float-icon--wa"><Icon name="message-circle" size={14} /></span>
      <span><strong>“Your order has shipped”</strong><small>WhatsApp · LR 55120 with tracking</small></span>
    </div>
  </div>
);

const EVENTS = [
  { icon: 'credit-card', title: 'Shopper pays ₹2,539', chip: ['Razorpay', 'accent'], desc: 'Sales order for the shopper, invoice number allocated, held stock allocated, receipt voucher booked as an advance.' },
  { icon: 'truck', title: 'You dispatch', chip: ['LR + tracking', 'info'], desc: 'The shipment leaves with your transporter; stock leaves the shelf once and the shopper gets the tracking link.' },
  { icon: 'package-check', title: 'Delivered', chip: ['Completed', 'ok'], desc: 'The order is closed and the shopper is told it has arrived — by email and on WhatsApp.' },
];

const OrderTimeline = () => (
  <div className="pp-doc" role="img" aria-label="What Raya ERP records for one online order, from payment to delivery">
    <div className="pp-doc-head">
      <span>Online order IL-1042 · ₹2,539</span>
      <span className="pp-chip pp-chip--ok">In Raya ERP</span>
    </div>
    <ul className="pp-timeline">
      {EVENTS.map((e) => (
        <li key={e.title}>
          <span className="pp-timeline-dot"><Icon name={e.icon} size={14} /></span>
          <div>
            <p className="pp-timeline-title">{e.title}<span className={`pp-chip pp-chip--${e.chip[1]}`}>{e.chip[0]}</span></p>
            <p className="pp-timeline-desc">{e.desc}</p>
          </div>
        </li>
      ))}
    </ul>
    <div className="pp-doc-foot"><Icon name="info" size={13} />Illustrative order: one cushion cover (₹649) and one throw (₹1,890).</div>
  </div>
);

const OnlineStorePage = () => (
  <ProductPage page={ONLINE_STORE_PAGE} heroVisual={<StorefrontMock />} booksVisual={<OrderTimeline />} />
);

export default OnlineStorePage;
